export const domScriptInjectAsync = (src, target = "head") => new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;
    script.src = src;
    script.addEventListener("load", () => {
        resolve();
    });
    script.addEventListener("error", () => reject(new Error("Error loading script. " + src)));
    script.addEventListener("abort", () => reject(new Error("Script loading aborted. " + src)));
    document[target].appendChild(script);
});
export const domNoscriptInject = (innerHTML, target) => {
    const noscript = document.createElement("noscript");
    noscript.innerHTML = innerHTML;
    document[target].appendChild(noscript);
};
export const domCssInject = (src, target = "head") => {
    const link = document.createElement("link");
    link.href = src;
    link.type = "text/css";
    link.rel = "stylesheet";
    document.getElementsByTagName(target)[0].appendChild(link);
};
//# sourceMappingURL=dom.js.map